// extracted by mini-css-extract-plugin
export default {"appLoading":"AppLoading_appLoading__Zsjf2","spinner":"AppLoading_spinner__YhP8i","rotation":"AppLoading_rotation__9LOah","spinner_2022":"AppLoading_spinner_2022__9TtY+"};